<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */

import { useMainStore } from "@/store/main/index";
import Calendar from "@/components/regularComponents/UIComponents/SVG/Footer/Calendar.vue";
import Call from "@/components/regularComponents/UIComponents/SVG/Footer/Call.vue";
import Button from "@/components/regularComponents/UIComponents/Button.vue";

const mainStore = useMainStore();

defineProps<{
  hideCallBtn?: boolean;
}>();

defineEmits<{
  (e: "openBooking"): void;
}>();

onBeforeMount(async () => {
  if (!mainStore.widgets?.["working-hours"]) {
    await mainStore.setWidgets(["working-hours"]);
  }
});
</script>

<template>
  <div
    class="working-hours contact-block--mx-default"
    v-if="mainStore.widgets?.['working-hours']"
  >
    <div class="contact-block__info-head">
      {{ mainStore.widgets?.["working-hours"]?.title }}
    </div>

    <div class="d-flex j-btw working-hours-in">
      <div class="d-flex al-center">
        <div class="d-flex icon-default al-center">
          <Calendar />
        </div>
        <div class="value" v-html="mainStore.widgets?.['working-hours'].hours" />
      </div>

      <Button
        v-if="!hideCallBtn"
        class="btn"
        btnText="book a call"
        @click="$emit('openBooking')"
      >
        <div class="d-flex btn-icon mr-8">
          <Call />
        </div>
      </Button>
    </div>
  </div>
</template>

<style lang="scss">
.working-hours {
  padding-top: 102px;
  padding-bottom: 108px;

  @include maxq(desktop-2k) {
    padding-top: 67px;
    padding-bottom: 76px;
  }

  @include maxq(desktop-lg) {
    padding-top: 48px;
    padding-bottom: 57px;
  }

  @include maxq(desktop) {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  @include maxq(tablet) {
    @include border(right);
  }

  @include maxq(mobile) {
    padding-bottom: 40px;
  }
  .value {
    @include weight(400);
    font-size: 34px;
    line-height: 48px;
    margin-left: 29px;

    @include maxq(desktop-2k) {
      font-size: 22px;
      line-height: 32px;
    }

    @include maxq(desktop-lg) {
      font-size: 15px;
      line-height: 24px;
    }

    @include maxq(desktop) {
      font-size: 15px;
      line-height: 24px;
      margin-left: 14px;
      // width: 80%;
    }

    // @include maxq(mobile) {
    //     width: 50%;
    // }
  }

  .btn {
    // height: 114px;
    @include weight(500);
    font-size: 36px;
    line-height: 50px;

    &.button--1 {
      text-transform: unset;

      span {
        text-transform: unset;
      }
    }

    @include maxq(desktop-lg) {
      padding: 0 16px;
    }
    .button__content {
      font-size: 36px;
      line-height: 50px;

      @include maxq(desktop-2k) {
        font-size: 24px;
        line-height: 32px;
      }

      @include maxq(desktop-lg) {
        font-size: 15px;
        line-height: 24px;
      }

      @include mqMinMax(1248px, 1440px) {
        display: none;
      }
    }

    &-icon {
      margin-right: 13px;
      --w: 37px;

      svg {
        width: var(--w);
        height: var(--w);
      }

      @include maxq(desktop-2k) {
        margin-right: 8px;
        --w: 32px;
      }

      @include maxq(desktop-lg) {
        --w: 24px;
      }
    }

    @include maxq(mobile) {
      margin-top: 24px;
      width: 100%;
    }
  }

  &-in {
    @include maxq(mobile) {
      flex-direction: column;
    }
  }
  @include border(bottom);

  .icon-default {
    --w: 56px;

    @include maxq(desktop-2k) {
      --w: 34px;
    }

    @include maxq(desktop-lg) {
      --w: 24px;
    }

    width: var(--w);
    height: var(--w);
    svg {
      width: var(--w);
      height: var(--w);
    }
  }
}
</style>
